import styled from 'styled-components';
import { Content } from 'components/atoms/Content';
import { useTranslation } from 'next-i18next';
import { Breakpoints } from 'styles/theme';
import bgImage from 'public/fulfillment-service/warehouse-bg.jpeg';

const MainSection = styled.section`
    display: flex;
    text-align: center;
    align-items: center;
    padding: 60px 0;
    background-image: url('${bgImage.src}');
    background-size: cover;
    color: white;

    @media ${Breakpoints.lg} {
        /* padding: 100px 0 0; */

        h1 {
            font-size: 80px;
            margin: 0;
        }

        p {
            font-size: 30px;
            max-width: 960px;
            margin: 20px auto;
        }
    }
`;

const TextBackground = styled.section`
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 25px;
    padding: 15px;
`;

export const FulfillmentServiceTitle: React.FunctionComponent = () => {
    const { t } = useTranslation('home');

    return (
        <MainSection>
            <Content>
                <TextBackground>
                    <h1>{t('eCommerce Fulfillment Service Center in Canada')}</h1>
                    <p>
                        {t(
                            'Delight your customers with fast & cheap 1-3 days delivery across Canada, and cheaper international shipments. Send us your items to one or more of our warehouses across Canada, and we will handle shipping for you.'
                        )}
                    </p>
                </TextBackground>
            </Content>
        </MainSection>
    );
};
